import { currentHostSettings } from 'utils/currentHost.utils';

export const useHostConfigs = () => {
  return currentHostSettings;
};
